mutation DocumentPoolUpdate($input: DocumentPoolUpdateInput!) {
  documentPoolUpdate(input: $input) {
    documentPools {
      id
      name
      description
      defaultDirectoryTypeId
      userGroupId
      defaultDocumentTypeId
      defaultBusinessUnitId
      defaultDepartmentId
      isShareableDefault
      isCreateCopyWithSelection
      isRetainedWithSelection
      isDocumentTypeSelector
      isBusinessUnitSelector
      isDepartmentSelector
      _rowTimestamp
      extractionTypeId
      documentPoolHistoriesByEntityId {
        nodes {
          crudOperation
          pointInTimeDate
          tenantUserName
        }
      }
      notesByEntityId {
        nodes {
          id
          _createdByUserName
          _createdDate
          noteComment
          isShared
          _isUpdatable
          _rowTimestamp
          _isDeletable
        }
      }
      documentPoolSecureRowLevels {
        id
        name
        description
        securityLevel
      }
    }
  }
}
